import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';

const dropdownItemStyles = css`
  display: flex;
  min-height: 40px;
  max-height: 72px;
  width: 100%;
  border-radius: var(${RadiusToken.Radius3});
  text-align: left;
  padding: var(${SpacingToken.Spacing2}) 0 var(${SpacingToken.Spacing2})
    var(${SpacingToken.Spacing4});
  transition-duration: 0.2s;
  transition-property: background-color;
  transition-timing-function: cubic-bezier(0.64, 0, 0.35, 1);

  color: var(${DesignToken.ContentBasicPrimary});
  text-decoration: none;

  &:hover {
    background: var(${DesignToken.SurfaceSecondaryDefault});
    text-decoration: none;
  }
`;

export const productItemStyles = css`
  ${dropdownItemStyles};

  > img,
  span {
    height: 24px;
    width: 24px;
    margin-right: var(${SpacingToken.Spacing2});
  }
`;

export const labelStyles = css`
  color: var(${DesignToken.ContentBasicSecondary});
  margin-top: var(${SpacingToken.Spacing1});
  margin-bottom: 0;
  font-size: 14px;
`;

export const productTextContainerStyles = css`
  display: flex;
  flex-direction: column;
`;

export const buttonStyles = css`
  border: none;
  height: 40px;
  width: 100%;

  > div {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 0;
  }
`;

export const headingStyles = css`
  font-weight: 600;
`;
